export enum DocumentMode {
  Incoming = 'E',
  Outgoing = 'U',
  Internal = 'I',
  Registration = 'R'
}
